// removed by extract-text-webpack-plugin
module.exports = {"rbc-toolbar":"rbc-toolbar","toolbar-top-section":"toolbar-top-section","toolbar-bottom-section":"toolbar-bottom-section","selecting-view":"selecting-view","tab-select-button":"tab-select-button","rbc-active":"rbc-active","date-label":"date-label"};


//////////////////
// WEBPACK FOOTER
// ./src/components/classtop-react-big-calendar/Toolbar.scss
// module id = 2s5a
// module chunks = 0